<template></template>

<script>
export default {
	name: 'ShowTeamPositionsSlide',
};
</script>

<style></style>
